import React from 'react';

export default function ResponsiveImage({images,...rest}){

    // const isImagesSupplied = images ? true : false;
    // const defaultImage = 

    console.log('responsive image - images')
    console.log(images)

    const srcImage = images.file ? images.file : images.lg;

    return(
        <>
        {
            images.length > 1 
            ?
            <img src={images.sm} srcSet={`${images.sm} 300w , ${images.md} 768w , ${images.lg} 1280w`} {...rest}/>
            :
            <img src={srcImage}  {...rest}/>
        }
        </>
    );
    
}